/* Get header and footer heights */
document.addEventListener('DOMContentLoaded', function() {
  // Get the heights of the elements
  var header = document.querySelector('.section-header');
  var footer = document.querySelector('.section-footer');

  var headerHeight = header.offsetHeight;
  var footerHeight = footer.offsetHeight;

  // Set the CSS variables on the HTML tag
  document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
  document.documentElement.style.setProperty('--footer-height', footerHeight + 'px');
});

window.addEventListener('scroll', function() {
  if (window.scrollY > 10) {
    document.body.classList.add('scrolling');
  } else {
    document.body.classList.remove('scrolling');
  }
});